import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import SelectBox from "../../../../components/SelectBox";
import "./index.css";

const IncomeCallPop = ({ data, onSelectPlant }) => {
  //차량 검색 URL
  //공통코드 검색 URL
  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";
  const [scrapAreaCd, setScrapAreaCd] = useState("");
  const [show, setShow] = useState(true);
  const handleClose = (returnData) => {
    setShow(false);
  };

  const initItem = {
    scrapAreaCd: "",
    scrapAreaNm: "",
    ...data,
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  //console.log(data);

  const handleOk = (returnData) => {
    if (fieldValues.scrapAreaCd === "") {
      alert("하차지역을 선택하지 않았습니다. ");
    } else {
      onSelectPlant(fieldValues);
      setShow(false);
    }
  };

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
    setFieldValues({
      ...fieldValues,
      [name]: value,
      ["scrapAreaNm"]: scrapAreaNm,
    });
  });

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title> 입차호출</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="call">
            <SelectBox
              mastCd="SCRAP_AREA_CD"
              id="scrapAreaCd"
              name="scrapAreaCd"
              topSelected="선택"
              attr7="Y"
              attr3={
                data.transStatusCd === "A" ? data.plantCd : data.poaPlantCd
              }
              onChange={handleChangeField}
              value={fieldValues.scrapAreaCd}
              className="ip2"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-secondary"
            onClick={() => handleClose(false)}
          >
            취소
          </Button>

          <Button className="btn btn-primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalIncomeCallPop = createModal(IncomeCallPop);

export default IncomeCallPop;
